<template>
  <div class="aw-cases">
    <div class="com-sub-top">
      <div class="title container-center">案例</div>
    </div>

    <div class="com-desc-box">
      <div class="container-center advantage">
        <div class="cases-box">
            <div class="m-cases-list">
                <ul class="cases-list">
                    <li v-for="item in cases" :key="item.categoryId" @click="choose(item)" :class="{active : key == item.categoryId}">
                        <span class="circle"></span>
                        <span >{{item.categoryName}}</span>
                    </li>
                </ul>
            </div>
            <div class="showName">{{showName}}</div>
            <ul class="cases-card">
                <li v-for="(item,index) in showList" :key="index" @click="goDetail(item)">
                    <img class="logo" :src="item.caseLogo" alt="">
                    <p class="cases-card-title">{{item.caseTitle}}</p>
                    <p class="cases-card-desc">{{item.caseSummary}}</p>
                    <i class="icon iconfont icon-fj-btnback arrow" ></i>
                </li>
            </ul>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryCaseCategory, queryListByCategory } from "@/api/common.js"
export default {
    data() {
        return {
            cases: [
                // {categoryName: '教育(云)', categoryId: "1", },
                // {categoryName: '医疗', categoryId: "2"},
                // {categoryName: '传媒', categoryId: "3"},
                // {categoryName: '政务', categoryId: "4"},
                // {categoryName: '科研', categoryId: "5"},
                // {categoryName: '电信、能源', categoryId: "6"},
                // {categoryName: '金融', categoryId: "7"},
                // {categoryName: '教育(人工智能)', categoryId: "8"},
                // {categoryName: '新能源汽车', categoryId: "9"},
                // {categoryName: '其他', categoryId: "10"},
            ],
            key: '1',
            showList: [],
            showName: ''

        }
    },
    methods: {
        choose(val) {
            this.showName = val.categoryName;
            this.key = val.categoryId;
            this.queryList()
        },
        queryCasesClass() {
            this.showList = []
            queryCaseCategory().then(res => {
                if(res && res.code == 200) {
                    this.cases = res.data
                    this.key = res.data[0].categoryId
                    this.showName = res.data[0].categoryName
                    this.queryList()
                }
            })
        },
        queryList() {
            queryListByCategory({categoryId: this.key, pageNum: 1, pageSize: 1000}).then(res => {
                if(res && res.code == 200) {
                    this.showList = res.rows
                }
            })
        },
        goDetail(item) {
            this.$router.push({ name: 'caseDetail', query: { id: item.caseId } });
        }
    },
    mounted() {
        // 获取案例分类
        this.queryCasesClass()
    }
}
</script>